<template>
  <span>
    <span class="screenplay-shadow"></span>
    <span :class="customClass" class="screenplay-holder">
      <span class="screenplay-holder-info">
        <span class="screenplay-holder__header">
          <span class="screenplay-holder__title"></span>
          <a @click="closeThirdTutorial" class="screenplay-holder__close"></a>
        </span>
        <!-- screenplay-holder__header -->
        <span
          v-if="numberId"
          class="screenplay-holder__content text-center"
          v-html="project.UF_HELP.SCENARIO.STEP3[step][numberId]"
        />
        <span
          v-else
          class="screenplay-holder__content text-center"
          v-html="project.UF_HELP.SCENARIO.STEP3[step]"
        />

        <!-- screenplay-holder__content -->
      </span>
      <!-- screenplay-holder-info -->
      <span class="screenplay-holder__footer">
        <span class="screenplay-holder__etap">
          шаг
          {{ project.ARR3.indexOf(stepName) + 1 }}
          из
          {{ project.ARR3.length }}
        </span>
        <span class="screenplay-holder__butt-area">
          <a
            v-if="project.ARR3.indexOf(stepName) > 0"
            @click="nextStepThirdTutorial($event, stepName, 'decrement')"
            class="screenplay-holder__butt screenplay-holder__butt-prev"
          >
            Шаг назад
          </a>
          <span v-else></span>
          <a
            @click="nextStepThirdTutorial($event, stepName, 'increment')"
            class="screenplay-holder__butt screenplay-holder__butt-next"
          >
            {{
              project.ARR3.indexOf(stepName) + 1 !== project.ARR3.length
                ? "Далее"
                : "Завершить"
            }}
          </a>
        </span>
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: "ThirdScenariosStep",
  props: ["project", "step", "stepName", "numberId", "customClass"],

  methods: {
    nextStepThirdTutorial(event, step, operation) {
      event.stopImmediatePropagation();
      const operations = {
        decrement: "-1",
        increment: 1
      };
      this.project[step] = false;
      const nextIndexStep =
        this.project.ARR3.indexOf(step) + Number(operations[operation]);
      if (nextIndexStep < this.project.ARR3.length) {
        this.project[this.project.ARR3[nextIndexStep]] = true;
        const el = this.$parent.$refs[this.project.ARR3[nextIndexStep]];
        if (el) {
          if (Array.isArray(el)) {
            el[0].scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          } else {
            el.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
        }
      } else {
        this.closeThirdTutorial();
      }
    },
    closeThirdTutorial() {
      event.stopImmediatePropagation();
      const el = document.getElementsByClassName("area-shadow")[0];
      el.classList.remove("active");
      const footer = document.getElementsByClassName("footer")[0];
      footer.classList.remove("active");
      this.project.ARR3.forEach(el => {
        if (el in this.project) {
          this.project[el] = false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
